import { useMakeInKindDonation } from '@/actions/campaign.actions';
import { map, some } from 'lodash-es';
import React from 'react';
import Button from '../next-ui/Button';
import Typography from '../next-ui/Typography';
import InKindDonationItem from './InKindDonationItem';

function InKindPledgeForm(props) {
  const { post, onSubmit } = props;
  const [donations, setDonations] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const campaign = post.sourcePostData;
  const { inKindDonations } = post.renderProps;

  const { mutateAsync: makeInKindDonation, isError } = useMakeInKindDonation();

  React.useEffect(() => {
    if (post) {
      const obj = {};
      inKindDonations.forEach((item) => {
        obj[item.id] = 0;
      });

      setDonations(obj);
    }
  }, []);

  const updateDonation = (givingLevelId, value) => {
    const numValue = Number(value);
    if (!Number.isNaN(numValue)) {
      const newDonations = { ...donations };
      newDonations[givingLevelId] = Number(value);
      setDonations(newDonations);
    }
  };

  const hasValidDonation = () => some(donations, (value) => value > 0);

  const handlePledgeChange = (value, item) => {
    updateDonation(item.id, value);
  };

  const handleSubmit = async () => {
    if (hasValidDonation()) {
      setIsSubmitting(true);
      const payload = {
        goods: map(donations, (value, key) => ({
          id: key,
          quantity: value,
        })).filter((item) => item.quantity > 0),
      };

      const res = await makeInKindDonation({
        campaignId: campaign.id || campaign._id, // TODO: check
        donations: payload,
      });

      setIsSubmitting(false);
      if (res) {
        onSubmit(res.donation);
      }
    }
  };

  return (
    <div className="flex w-full flex-col items-stretch gap-4">
      <div className="flex flex-col gap-8 rounded-lg bg-body-background p-6">
        {inKindDonations &&
          inKindDonations.map((item) => {
            return (
              <div
                key={item.id}
                className="flex items-center justify-between gap-4">
                <InKindDonationItem
                  item={item}
                  onChange={(val) => handlePledgeChange(val, item)}
                />
              </div>
            );
          })}
      </div>

      <Typography variant="body2">
        The items are to be delivered at <b>{campaign.address}</b>
      </Typography>

      {isError && (
        <Typography variant="body2" color="error">
          Something went wrong. Please try again.
        </Typography>
      )}

      <div className="flex w-full items-center justify-end gap-4">
        <Button onClick={handleSubmit} disabled={!hasValidDonation()}>
          Submit
        </Button>
      </div>
    </div>
  );
}

export default InKindPledgeForm;
